import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import React from 'react';

export default function CorporationOptionUsage({ optionUsages }) {
    if (Utils.isEmptyArray(optionUsages)) return null;

    return (
        <>
            {optionUsages?.map((option, index) => {
                return (
                    <div className="item-option-usage" key={index}>
                        <div className="title">{I18n.get(option.label)}</div>
                        <div className="option">{option.value} {option.unit}</div>
                    </div>
                );
            })}
        </>
    );
}
